import {createRouter, createWebHistory} from "vue-router";

import HomeView from "../views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import ServiceView from "../views/ServiceView.vue";
import CareerView from "@/views/CareerView.vue";
import ImpressumView from "@/views/ImpressumView.vue";
import DatenschutzView from "@/views/DataSecurityView.vue";
import ContactView from "@/views/ContactView.vue";

const routes = [
    {path: "/", name: "home", component: HomeView},
    {path: "/about", name: "about", component: AboutView},
    {path: "/services", name: "services", component: ServiceView},
    {path: "/career", name: "career", component: CareerView},
    {path: "/impressum", name: "impressum", component: ImpressumView},
    {path: "/datenschutz", name: "datenschutz", component: DatenschutzView},
    {path: "/contact", name: "contact", component: ContactView},


];

const scrollBehavior = (
    _to: unknown,
    _from: unknown,
    _savedPosition: { left: number; top: number } | null
) => {
    return _savedPosition ?? {top: 0}
}

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior
})

export default router;
